import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import getGroupInfoById from "./getGroupInfoById";

const getChallengeGroupList = async function(competition_id) {
  let db = firebase.firestore();

  const competitionSnapshot = await db
    .collection("wellness_competition")
    .doc(competition_id)
    .collection("users")
    .get();

  const userList = [];
  const itemList = [];
  competitionSnapshot.forEach((doc) => {
    // focus only record start BMI > 25 and end Weigth > 0
    userList.push({
      groupId: doc.data().groupId,
      startBMI: doc.data().startBMI,
      endBMI: doc.data().endBMI,
      startWeight: doc.data().startWeight,
      endWeight: doc.data().endWeight,
      healthPoint: doc.data().healthPoint
    });
  });

  //Summary group data
  if (userList.length) {
    let summaryGroupDataReport = userList.reduce((group, data) => {
      if (data.groupId == undefined) {
        data.groupId = "no group id";
      }
      if (group[data.groupId] == undefined) {
        group[data.groupId] = {
          bmi: 0,
          weight: 0,
          healthPoint: 0,
          cnt: 0,
        };
      }

      if (data.startBMI > 25 && data.endWeight > 0) {
        ++group[data.groupId]["cnt"];
        if (data.startBMI && data.endBMI) {
          group[data.groupId]["bmi"] =
            (group[data.groupId]["bmi"] || 0) + (data.endBMI - data.startBMI);
        }
        if (data.endWeight && data.startWeight) {
          group[data.groupId]["weight"] =
            (group[data.groupId]["weight"] || 0) +
            (data.endWeight - data.startWeight);
        }
        if (data.healthPoint) {
          group[data.groupId]["healthPoint"] =
            (group[data.groupId]["healthPoint"] || 0) + data.healthPoint;
        }
      }
      return group;
    }, {});

    await Promise.all(
      Object.entries(summaryGroupDataReport).map(async ([groupId, data]) => {
        if (groupId != "no group id") {
          const groupInfo = await getGroupInfoById(groupId);

          let bmiAverage = data["cnt"] > 0 ? data["bmi"] / data["cnt"] : 0;
          itemList.push({
            id: groupId,
            name: groupInfo.name,
            BMI: bmiAverage,
            weight: data["weight"],
            healthPoint: data["healthPoint"]
          });
        }
      })
    );
  }
  return itemList;
};

export default getChallengeGroupList;
